import {showErrorNotification, showSuccessNotification} from "../global/notifications";

export default function () {
    attachOnDateChangeEvent();
}

const initializeSection = () => {
    attachAutoPopulateEvent();
    attachSaveEvent();
};

const attachAutoPopulateEvent = () => {
    const $allCompanies = $('[data-for-company="0"]');
    if ($allCompanies.length) {
        $allCompanies.on('blur', function () {
            const thisValue = $(this).data('kendoNumericTextBox').value();
            const thisSection = $(this).attr('data-for-section');

            $.each($('.js-percentage-form').find(`input[data-for-section="${thisSection}"]`), function (index, ele) {
                const k_input = $(ele).data('kendoNumericTextBox');
                if (k_input) {
                    k_input.value(thisValue);
                }
            })
        })
    }
};

const attachSaveEvent = () => {
    const $saveButton = $('#SavePercentages_Construction, #SavePercentages_Service');

    if ($saveButton.length) {
        $saveButton.on('click', function (e) {
            e.preventDefault();
            const $form = $('form.js-percentage-form');
            $.post(`/Forms/AccrualMarkup/SavePercentages?${$form.serialize()}`, function(response){
                if(response.success){
                    showSuccessNotification('Save Successful');
                }else{
                    showErrorNotification(`Failed to save ${response.failedToSave} ${response.failedToSave > 1 ? 'responses' : 'response'}!`)
                }
            })
        });
    }
};

const attachOnDateChangeEvent = () => {
    let $quarter = $('#quarter');

    if ($quarter.length) {
        $quarter.on('change', function () {
            let k_quarter = $(this).data('kendoDropDownList');

            if (k_quarter && k_quarter.value() !== '') {
                let data = {
                    dateTime : k_quarter.value()
                };
                $('.js-percentage-section').load('/Forms/AccrualMarkup/LoadPercentages', data, function () {
                    initializeSection();
                })
            }else{
                $('.js-percentage-section').html('');
            }
        })
    }
};